import React from 'react';
import { useTranslation } from 'react-i18next';
import { Loader } from './Loader';

interface PageLoaderProps {
  show: boolean;
}

export const PageLoader: React.FC<PageLoaderProps> = ({ show }) => {
  const { t } = useTranslation();

  if (!show) return null;

  return (
    <div className="absolute inset-0 flex items-center justify-center z-10 bg-white dark:bg-gray-900 bg-opacity-95 dark:bg-opacity-95">
      <Loader message={t('common.loading')} size="lg" />
    </div>
  );
};
